import { Anchor, Box, Button, ResponsiveContext, Text } from "grommet";
import { Phone, PhoneVertical, Chat } from "grommet-icons";
import CenteredColumn from "../components/CenteredColumn";
import GroupHeader from "../components/GroupHeader";
import SubHeader from "../components/Subheader";
import PageHeader from "../components/PageHeader";
import riverRock from "../assets/RiverRock2.jpg";
import { useContext } from "react";
import AppContext from "../stateManager/appContext";

const StyledResource = (props) => {
  return (
    <Box
      pad={{ left: "large", bottom: "medium" }}
      direction="row-responsive"
      gap="small"
    >
      {props.children}
    </Box>
  );
};

const ResourcesPage = () => {
  const viewportSize = useContext(ResponsiveContext);

  const { siteData } = useContext(AppContext);

  if (!siteData) {
    return null;
  }

  const StyledButton = (props) => {
    return (
      <Button
        color={"dark-4"}
        size="xsmall"
        pad={"xsmall"}
        {...props}
        label={
          <Text size="small" color={"dark-4"}>
            {props.label}
          </Text>
        }
      />
    );
  };

  return (
    <Box>
      <PageHeader label={siteData.resourcesPage.title} />

      <CenteredColumn columnWidth="large">
        <Text alignSelf="center" textAlign="center">
          <i>
            We do not provide crisis services. If you need emergency support
            outside of regular business hours we have included contact
            information below.
          </i>
        </Text>
      </CenteredColumn>
      <CenteredColumn columnWidth="xxlarge">
        <Box
          gap="medium"
          direction={viewportSize === "small" ? "column-reverse" : "row"}
          justify="center"
          pad={"large"}
        >
          <Box
            width={"medium"}
            height={'large'}
            round="small"
            background={{
              image: "url(" + riverRock + ")",
              position: "center",
            }}
            alignSelf="center"
          >
          </Box>
          <Box justify="center" gap="small">
            <Box pad="medium">
              <GroupHeader>SUICIDE PREVENTION</GroupHeader>
              <SubHeader>988 Suicide and Crisis Life Line</SubHeader>
              <StyledResource>
                <Box justify="center">
                  <Anchor href="https://988lifeline.org" target="_blank">
                    https://988lifeline.org
                  </Anchor>
                </Box>
                <StyledButton
                  icon={<Phone color="dark-4" />}
                  label="Call: 988"
                  href="tel:988"
                />
                <StyledButton
                  icon={<PhoneVertical color="dark-4" />}
                  label="Text"
                  href="sms:988"
                />
                <StyledButton
                  icon={<Chat color="dark-4" />}
                  label="Chat"
                  href="https://chat.988lifeline.org"
                />
              </StyledResource>

              <SubHeader>Suicide Prevention Lifeline</SubHeader>
              <StyledResource>
                <StyledButton
                  icon={<Phone color="dark-4" />}
                  label="Call: 800-273-8255"
                  href="tel:800-273-8255"
                />
              </StyledResource>

              <SubHeader>Crisis Text Line</SubHeader>

              <StyledResource>
                <Text size="medium">
                  Text HOME to 741741 to reach a live volunteer Crisis
                  Counselor.
                </Text>
              </StyledResource>
              <StyledResource>
                <Box justify="center">
                  <Anchor href="https://crisistextline.org" target="_blank">
                    https://crisistextline.org
                  </Anchor>
                </Box>
                <StyledButton
                  icon={<PhoneVertical color="dark-4" />}
                  label="Text"
                  href="sms:741741?&body=HOME"
                />
                <StyledButton
                  icon={<Chat color="dark-4" />}
                  label="Chat"
                  href="https://connect.crisistextline.org/chat"
                />
              </StyledResource>
            </Box>
            <Box pad="medium">
              <GroupHeader>DOMESTIC/SEXUAL VIOLENCE</GroupHeader>
              <SubHeader>YWCA crisis line</SubHeader>
              <StyledResource>
                <StyledButton
                  icon={<Phone color="dark-4" />}
                  label="Call: 406-542-1944"
                  href="tel:406-542-1944"
                />
                <StyledButton
                  icon={<Phone color="dark-4" />}
                  label="Call Toll Free: 800-483-7858"
                  href="tel:800-483-7858"
                />
              </StyledResource>
            </Box>
          </Box>
        </Box>
      </CenteredColumn>
    </Box>
  );
};
export default ResourcesPage;
